import { makeStyles, createStyles } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles(() =>
    createStyles({
        option: {
            display: 'flex',
            flexDirection: 'column',
            padding: '3px 5px',
        },
        publicName: {
            fontStyle: 'normal',
            fontWeight: 'normal',
            fontSize: '15px',
            lineHeight: '20px',
            color: '#424242',
        },
        internalName: {
            fontStyle: 'italic',
            fontWeight: 300,
            fontSize: '13px',
            lineHeight: '18px',
            color: '#757575',
            marginTop: '6px'
        }
    })
);

interface IProductListSearchItemProps {
    publicName: string;
    internalName?: string;
}

export function ProductListSearchItem({
    publicName,
    internalName
}: IProductListSearchItemProps) {
    const classNames = useStyles();

    return (
        <div className={classNames.option} data-component-name={'SEARCH_RESULT_ITEM'}>
            <span className={classNames.publicName}>{publicName}</span>
            <span className={classNames.internalName} style={{ fontStyle: 'italic' }}>{internalName}</span>
        </div>
    );
}
